<template>
  <div>
    <v-text-field outlined v-validate="validator" :value="value" @input="$emit('input', $event)" label="Número" :class="[(errors.first(field) || error) && 'block']" :error-messages="errors.first(field)" :name="field" v-bind="config" />
  </div>
</template>

<script>
export default {
  inject: ['$validator'],
  props: {
    value: String,
    field: String,
    config: Object,
    validator: Object,
  },
  data: () => ({
    error: null,
  }),
}
</script>

<style></style>
